import React from 'react';
import { Link } from 'react-router-dom';
import { Check } from 'lucide-react';

const LandingPagePricing: React.FC = () => {
  const features = [
    'Acesso a +200.000 produtos prontos a vender',
    'Integração rápida via CSV e XML',
    'Envios e recolhas direto do painel',
    'Apenas 20% + IVA por venda',
    'Integração com a sua loja online',
    'Gestão centralizada de pedidos',
    'Suporte dedicado'
  ];

  return (
    <div className="py-16 px-4 md:px-10 max-w-7xl mx-auto" id="planos">
      <div className="text-center mb-12">
        <div className="inline-block mb-6 px-4 py-1 bg-[rgba(140,198,63,0.2)] rounded-full">
          <p className="text-[#8cc63f] font-semibold">PLANOS</p>
        </div>
        
        <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">
          Comece a vender sem custos iniciais
        </h2>
        <p className="text-xl max-w-4xl mx-auto mb-12 text-white/80">
          Aproveite a nossa oferta de lançamento e comece a vender sem mensalidade!
        </p>
      </div>

      <div className="flex justify-center">
        <div className="bg-[rgba(255,255,255,0.05)] p-8 rounded-lg max-w-md shadow-xl transform hover:scale-[1.03] transition-transform relative border border-[#8cc63f]/30">
          <div className="absolute top-0 right-0 bg-[#8cc63f] text-white px-4 py-1 rounded-bl-lg font-bold">
            POPULAR
          </div>
          <div className="mb-4">
            <Link to="/register" className="inline-block px-8 py-3 text-xl rounded-lg bg-[#8cc63f] text-white hover:bg-[#7ab52f] transition-colors font-bold w-full text-center">
              COMEÇAR AGORA
            </Link>
          </div>
          <div className="text-3xl font-bold mb-2 text-[#8cc63f]">GRÁTIS</div>
          <div className="text-xl mb-4 text-amber-300">Em breve: 19,99€/mês</div>
          <div className="text-lg mb-6 text-white">Aproveite enquanto é grátis!</div>
          <div className="text-xl font-semibold mb-6 text-white">Tudo o que precisa para vender online</div>
          
          <ul className="text-left mb-6 space-y-4">
            {features.map((feature, index) => (
              <li key={index} className="flex items-start">
                <div className="bg-[#8cc63f] rounded-full p-1 mr-3 mt-0.5">
                  <Check className="h-4 w-4 text-white" />
                </div>
                <span className="text-white">{feature}</span>
              </li>
            ))}
          </ul>

          <div className="mt-8">
            <Link to="/register" className="inline-block px-8 py-3 text-xl rounded-lg bg-white text-[#0a192f] hover:bg-[#8cc63f] hover:text-white transition-colors font-bold w-full text-center">
              REGISTAR AGORA
            </Link>
          </div>
        </div>
      </div>

      <div className="mt-8 text-center">
        <div className="mt-6 text-amber-300 p-4 border border-amber-300 rounded-lg max-w-3xl mx-auto">
          <p><strong>Importante:</strong> Para vender em marketplaces, os produtos precisam estar fisicamente no nosso armazém. Será cobrada apenas uma taxa de armazenamento pelo tempo que os produtos estiverem guardados.</p>
        </div>
      </div>
    </div>
  );
};

export default LandingPagePricing;
